import { create } from 'zustand';
import { AutVrfTknActivateResponse } from '../types/api/autVrfTknActivate';

interface TokensState {
  activateInfo: AutVrfTknActivateResponse | null;
  setActivateInfo: (res: AutVrfTknActivateResponse) => void;
  deviceActivateInfo: AutVrfTknActivateResponse | null;
  setDeviceActivateInfo: (res: AutVrfTknActivateResponse) => void;
  transPassword: string;
  setTransPassword: (s: string) => void;
  changeSmsAuthYn: string;
  setChangeSmsAuthYn: (s: string) => void;
  reset: () => void;
}

export const useTokensStore = create<TokensState>((set) => ({
  activateInfo: null,
  setActivateInfo: (res) =>
    set({
      activateInfo: res,
    }),
  deviceActivateInfo: null,
  setDeviceActivateInfo: (res) =>
    set({
      deviceActivateInfo: res,
    }),
  transPassword: '',
  setTransPassword: (s) =>
    set({
      transPassword: s,
    }),
  changeSmsAuthYn: 'N',
  setChangeSmsAuthYn: (s) =>
    set({
      changeSmsAuthYn: s,
    }),
  reset: () =>
    set({
      activateInfo: null,
      transPassword: '',
      changeSmsAuthYn: 'N',
    }),
}));
